import { useAppContext } from "../App";

interface StoryCardProps {
  id: number;
  title: string;
  username: string;
  likeCount: number;
  onClick: () => void;
}

export function StoryCard({ id, title, username, likeCount, onClick }: StoryCardProps) {
  const { likes } = useAppContext();
  const hasLiked = likes.includes(id);

  return (
    <div className="story-card" onClick={onClick}>
      <div className="story-card-username">@{username}</div>
      <div className="story-card-title">"{title}"</div>
      <div className="story-card-likes">
        <span className={`heart ${hasLiked ? "liked" : ""}`}>
          {hasLiked ? "♥" : "♡"}
        </span>
        <span>{likeCount}</span>
      </div>
    </div>
  );
}
